import { useEffect, useState } from "react";
import { getSeasonalTheme } from "@lib/seasonalTheme";
import "./SeasonalWelcome.css";

const SEASON_SYMBOLS = {
  autumn: ["🍂", "🍁"],
  winter: ["❄", "❅", "❆"],
  spring: ["", "", "", "", "", "", "", ""],
  summer: ["🌻"],
};

const SPRING_PETAL_COLORS = ["#ec6f9b", "#f3b544", "#8c83dc", "#ef8b52", "#d866a5", "#f1c85a", "#8dbb76", "#e87c78"];

// A gentle fall from the top edge across the full width: slow descent on the
// outer span, a soft side-to-side sway (and tumble) on the inner span.
const PARTICLES = [
  { x: 4, delay: 0, duration: 9.5, size: 20, sway: 26, swayDuration: 3.2 },
  { x: 15, delay: 1.6, duration: 8.4, size: 16, sway: -22, swayDuration: 2.8 },
  { x: 27, delay: 0.5, duration: 10.2, size: 22, sway: 30, swayDuration: 3.6 },
  { x: 38, delay: 2.4, duration: 8.8, size: 17, sway: -24, swayDuration: 3.0 },
  { x: 50, delay: 0.9, duration: 9.8, size: 21, sway: 28, swayDuration: 3.4 },
  { x: 62, delay: 3.1, duration: 8.2, size: 16, sway: -20, swayDuration: 2.7 },
  { x: 73, delay: 0.3, duration: 10.6, size: 23, sway: 32, swayDuration: 3.8 },
  { x: 85, delay: 1.9, duration: 9.0, size: 18, sway: -26, swayDuration: 3.1 },
  { x: 95, delay: 1.1, duration: 9.6, size: 19, sway: 22, swayDuration: 3.3 },
  { x: 9, delay: 3.6, duration: 8.9, size: 17, sway: -28, swayDuration: 3.5 },
  { x: 21, delay: 2.8, duration: 10.0, size: 20, sway: 24, swayDuration: 2.9 },
  { x: 44, delay: 4.2, duration: 9.2, size: 18, sway: -30, swayDuration: 3.7 },
  { x: 56, delay: 1.4, duration: 10.4, size: 16, sway: 20, swayDuration: 3.0 },
  { x: 68, delay: 4.6, duration: 8.6, size: 21, sway: -24, swayDuration: 3.3 },
  { x: 79, delay: 2.2, duration: 9.4, size: 17, sway: 26, swayDuration: 2.8 },
  { x: 91, delay: 3.9, duration: 10.1, size: 20, sway: -22, swayDuration: 3.6 },
];

// Unmount once the slowest particle has finished falling.
const LIFETIME_MS = Math.ceil(Math.max(...PARTICLES.map((p) => p.delay + p.duration)) * 1000) + 250;

function SeasonalWelcome() {
  const [visible, setVisible] = useState(true);
  const season = getSeasonalTheme().season;

  useEffect(() => {
    const timeout = window.setTimeout(() => setVisible(false), LIFETIME_MS);
    return () => window.clearTimeout(timeout);
  }, []);

  if (!visible) return null;

  return (
    <div className="seasonal-welcome" aria-hidden="true">
      {PARTICLES.map((particle, index) => (
        <span
          className="seasonal-welcome__faller"
          key={`${season}-${index}`}
          style={{
            "--particle-x": `${particle.x}%`,
            "--particle-delay": `${particle.delay}s`,
            "--particle-duration": `${particle.duration}s`,
            "--particle-size": `${particle.size}px`,
            "--particle-sway": `${particle.sway}px`,
            "--particle-sway-duration": `${particle.swayDuration}s`,
            "--petal-color": SPRING_PETAL_COLORS[index % SPRING_PETAL_COLORS.length],
          }}
        >
          <span className={`seasonal-welcome__particle seasonal-welcome__particle--${season}`}>
            {SEASON_SYMBOLS[season][index % SEASON_SYMBOLS[season].length]}
          </span>
        </span>
      ))}
    </div>
  );
}

export default SeasonalWelcome;
